'use strict';

require('styles/templates/page.mom.scss');

var _Video = require('components/Video');

document.addEventListener('DOMContentLoaded', function () {
	(0, _Video.init)();
});

window.addEventListener('load', function () {});